module.exports = __webpack_public_path__ + "img/mag-glass.b7424b94.svg";